<div class="search-item">
    <div class="left-half">
        <img class="image" src="{{itemObject.image}}" />
    </div>
    <div class="right-half">
        <div class="title">{{itemObject.title}}</div>
        <div class="text" [innerHTML]="itemObject.preview"></div>
    </div>
</div>